import { BaseModel } from '../base';
import { addressList } from '../../services/address_list';

class AddressModel extends BaseModel {
    constructor(data) {
        super(data);

        // Assign value to map_url if the value is an empty string.
        // Note: This is not ideal as it will not show a map marker. But the map_url property should already be set,
        // so this is just a fallback.
        if (!this.map_url) {
            if (this.lat && this.long) {
                this.map_url = `https://www.google.com/maps/@${this.lat},${this.long},17z`;
            }
        }
    }

    /**
     * @description
     * Checks if this is considered a valid address
     *
     * @returns {boolean} If this is a valid address
     */
    hasAddress() {
        return this.address1 || this.address2 || this.postcode;
    }

    /**
     * @description
     * Get a the address as a single comma separated line.
     *
     * @param separator custom separator.
     * @param properties List of address properties to be included in the output string.
     * @returns {string} The returned address
     */
    addressSingleLine({ properties = [], separator } = {}) {
        const ADDRESS_SEPARATOR = separator || ', ';

        return [
            this.address1,
            this.address2,
            this.address3,
            this.address4,
            this.address5,
            this.postcode,
            ...properties.map(property => this[property])
        ].filter(entry => entry).join(ADDRESS_SEPARATOR);
    }

    /**
     * @description
     * Get all address fields as a single comma separated line - suitable for csv export.
     *
     * @param properties List of address properties to be included in the output string.
     * @param separator custom separator.
     * @returns {string} The returned address
     */
    addressCsvLine({ properties = [], separator } = {}) {
        const ADDRESS_SEPARATOR = separator || ', ';

        return [
            this.address1,
            this.address2,
            this.address3,
            this.address4,
            this.address5,
            this.postcode,
            this.country,
            ...properties.map(property => this[property])
        ].filter(entry => entry).join(ADDRESS_SEPARATOR);
    }

    /**
     * @description
     * Get a the address as multiple lines with line feeds
     *
     * @param separator custom separator.
     * @param properties List of address properties to be included in the output string.
     * @returns {string} The returned address
     */
    addressMultiLine({ properties = [], separator } = {}) {
        const ADDRESS_SEPARATOR = separator || ',<br/>';

        return [
            this.address1,
            this.address2,
            this.address3,
            this.address4,
            this.address5,
            this.postcode,
            ...properties.map(property => this[property])
        ].filter(entry => entry).join(ADDRESS_SEPARATOR);
    }

    static $query(prms) {
        return addressList.query(prms);
    }

    static $getAddress(prms) {
        return addressList.getAddress(prms);
    }
}

export {
    AddressModel
};
